import React, { useState, useEffect, useRef } from "react";
import { clearToken } from "../api";

interface UserDropdownProps {
  userName: string;
  userPlan: string;
  onSettingsClick: () => void;
}

export function UserDropdown({ userName, userPlan, onSettingsClick }: UserDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  function handleLogout() {
    clearToken();
    window.location.href = "/login";
  }

  function handleSettings() {
    setIsOpen(false);
    onSettingsClick();
  }

  return (
    <div className="user-dropdown-container" ref={dropdownRef}>
      <div className="user-profile" onClick={() => setIsOpen(!isOpen)}>
        <div className="user-avatar">{userName.charAt(0).toUpperCase()}</div>
        <div className="user-info">
          <div className="user-name">{userName}</div>
          <div className="user-plan">
            {userPlan === "pro" ? "Pro Plan" : userPlan === "enterprise" ? "Enterprise" : "Free Plan"}
          </div>
        </div>
        <span className={`material-symbols-outlined user-settings-btn ${isOpen ? "open" : ""}`}>
          {isOpen ? "expand_more" : "expand_less"}
        </span>
      </div>

      {isOpen && (
        <div className="user-dropdown-menu">
          <button className="user-dropdown-item" onClick={handleSettings}>
            <span className="material-symbols-outlined">settings</span>
            <span>Settings</span>
          </button>
          <button className="user-dropdown-item" onClick={handleLogout}>
            <span className="material-symbols-outlined">logout</span>
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
}
